import { createBrowserRouter, type RouteObject } from "react-router";
import { AppShell } from "../layout/AppShell";
import { RootPage } from "./RootPage";
import { NotFoundPage } from "./NotFoundPage";

import { QuickAddPage } from "../features/quickAdd/QuickAddPage";
import {
  AccountsPage,
  ActivityPage,
  BudgetPage,
  CategoryPage,
  ImportPage,
  OnboardingPage,
  RegisterPage,
  ReportsPage,
  SettingsPage,
  TransactionPage,
} from "./pages";

export const appRoutes: RouteObject[] = [
  {
    element: <AppShell />,
    children: [
      { index: true, element: <RootPage /> },
      { path: "budget/:month?", element: <BudgetPage /> },
      { path: "accounts", element: <AccountsPage /> },
      { path: "accounts/:accountId", element: <RegisterPage /> },
      { path: "activity", element: <ActivityPage /> },
      { path: "add", element: <QuickAddPage /> },
      { path: "category/:categoryId/:month?", element: <CategoryPage /> },
      { path: "transactions/:txnId", element: <TransactionPage /> },
      { path: "import/*", element: <ImportPage /> },
      { path: "reports/*", element: <ReportsPage /> },
      { path: "settings/*", element: <SettingsPage /> },
      { path: "welcome", element: <OnboardingPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(appRoutes);
}
